import React from 'react';

export default function CrashScreen({ onReload, errorId }) {
	return (
		<div style={{
			fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
			padding: 24, lineHeight: 1.5
		}}>
			<h2 style={{marginTop:0}}>Щось пішло не так</h2>
			<p>Ми зафіксували помилку та повідомили бекенд. Ви можете спробувати оновити сторінку.</p>
			{errorId ? <p style={{opacity:.7}}>ID інциденту: <code>{errorId}</code></p> : null}
			<button
				onClick={onReload}
				style={{
					padding: '10px 14px', borderRadius: 8, border: '1px solid #ccc',
					cursor: 'pointer', background: '#fff'
				}}
			>
				Оновити сторінку
			</button>
		</div>
	);
}
